<template>
  <div class="list-of-create-room">
      <ChatBoxTitle>
        <div slot="left">
          <!-- <img class="hide-desktop" src="../img/home.svg" @click="$router.push('/') " alt="Home" title="Home"> -->
          <img class="hide-desktop" src="../img/on-ui.svg" @click="$emit('switch', 'off')" alt="Home" title="Home">
          <!-- <img class="" src="../img/qr.svg" style="cursor: pointer;" @click="() => { show = 'qrcode' }" alt="Qr Code"> -->
        </div>
        <div slot="center">
          Create Room
          <!-- <a class="title-link" target="_blank" :href="`https://yoteachapp.com/room/${room._id}`" v-if="room && room.title">{{ room.title }}</a> -->
        </div>
        <div slot="right">
          <!-- <img class="hide-desktop" src="../img/search.svg" @click="$emit('bar', 'search')" alt="Search room" title="Search room"> -->
          <!-- <img src="../img/qr.svg" style="cursor: pointer;" @click="() => { show = 'qrcode' }" alt="Qr Code"> -->
          <!-- <img src="../img/dot3.svg" @click="show = 'features'" alt="Menu" style="cursor: pointer;"> -->
        </div>
      </ChatBoxTitle>
      <section class="input-section">
        <div class="single-input-grouper">
          <input class="red-round-box" style="width: 80%;" placeholder="Title of Room" type="text" v-model="newRoom.title" />
        </div>
        <div class="red" v-if="notAlphaNumeric">not alpha numeric or _ or -</div>
        <!-- <div class="red" v-if="msgs.find(i => i.id === 503)">
          {{ msgs.find(i => i.id === 503).msg }}
        </div> -->
      </section>

      <section class="input-section single-input-grouper">
        <div style="width: 80%;">
          <textarea class="red-round-box red-textarea" style="width: 100%;" placeholder="description" v-model="newRoom.desc"></textarea>
        </div>
      </section>

      <div class="additional-features">
        <section class="input-section">
          <div>
            <strong>Hide from Search Result: </strong><input type="checkbox" v-model="newRoom.hideFromSearchResult" />
          </div>
        </section>

        <section class="input-section">
        <div>
          <strong>Enable admin features:</strong> <input type="checkbox" v-model="newRoom.enableRoomAdminFeatures" />
        </div>
        </section>
        <div class="black" v-show="newRoom.enableRoomAdminFeatures">
            <div>
              To enable room owner badge, delete room option, mute student and message delete features, student participation statistics, like comment button, a choice between chatroom vs. voting mode, please set your room's password.
            </div>
            <div>
              Room Admin password: <br/> <input type="password" v-model="newRoom.roomAdminPassword" />
            </div>
            <div>
              Password Restore Question: <br/> <input type="text" placeholder="What is the name of your pet?" v-model="newRoom.roomAdminPasswordRecoveryQuestion" />
            </div>
            <div>
              Password Restore Answer: <br/> <input type="text" placeholder="Happy Hamster" v-model="newRoom.roomAdminPasswordRecoveryAnswer" />
            </div>
        </div>

        <div>
          <strong>Enable entry Password:</strong> <input type="checkbox" v-model="newRoom.enableRoomEntryPassword" />
        </div>

        <div v-show="newRoom.enableRoomEntryPassword">
          <div>
            <!-- <strong>Room Entry Password:</strong> -->
            <input type="password" placeholder="Entry Password" class="red-round-box" v-model="newRoom.roomEntryPassword" />
          </div>
        </div>
        <div>
          <button class="red-round-box red-submit-btn" v-if="!loading" @click="createRoom">
            {{ cta }}
          </button>
          <button disabled="disabled" v-if="loading">
            Loading...
          </button>

          <div :key="msg.id" v-for="msg in msgs" class="red">{{ msg.msg }}</div>
        </div>
      </div>

      <TabBar @bar="(v) => { $emit('bar', v) }"></TabBar>

      <!-- <div v-if="$debug">
        <h2>new room</h2>
        <pre>{{ newRoom }}</pre>
        <h2>result</h2>
        <pre>{{ result }}</pre>
      </div> -->
  </div>
</template>

<script>
import { API } from '@/yoteach2-gui/parts/index.js'
import _ from 'lodash'
import validator from 'validator'
import ChatBoxTitle from './ChatBoxTitle'
import TabBar from './TabBar'

export default {
  components: {
    ChatBoxTitle,
    TabBar
  },
  data () {
    let template = {
      title: '',
      desc: '',

      hideFromSearchResult: false,

      enableRoomAdminFeatures: false,
      roomAdminPassword: '',
      roomAdminPasswordRecoveryQuestion: '',
      roomAdminPasswordRecoveryAnswer: '',

      enableRoomEntryPassword: false,
      roomEntryPassword: '',

      sortMethod: 'chat',

      adminUUIDs: [],
      mutedUUIDs: []
    }
    return {
      notAlphaNumeric: false,
      loading: false,
      template,
      newRoom: JSON.parse(JSON.stringify(template)),
      cta: 'create room',
      result: false,
      msgs: []
    }
  },
  computed: {
    newName () {
      return this.newRoom.title
    }
  },
  watch: {
    newName () {
      this.notAlphaNumeric = this.notOkayTitleString(this.newName)
      this.checkRoomNameTaken({ title: this.newName || '' })
    }
  },
  methods: {
    checkRoomNameTaken: _.debounce(function ({ title }) {
      this.checkUniqueTitle({ title })
    }, 300),
    checkUniqueTitle ({ title }) {
      return API.checkRoomNameTaken({
        title
      }).then(() => {
        var idx = this.msgs.findIndex(m => m.id === 503)
        if (idx !== -1) {
          this.msgs.splice(idx, 1)
        }
        return true
      }, () => {
        if (this.msgs.findIndex(m => m.id === 503) === -1) {
          this.msgs.push({ id: 503, msg: 'Room name is taken' })
        }
        return false
      })
    },
    reset () {
      this.newRoom = JSON.parse(JSON.stringify(this.template))
    },
    notOkayTitleString (v) {
      /* eslint-disable */
      return !(
        validator.isAlphanumeric(v)
        || (
             !(validator.contains(v, '/'))
          && !(validator.contains(v, `\\`))
          && !(validator.contains(v, `*`))
          && !(validator.contains(v, `!`))
          && !(validator.contains(v, `#`))
          && !(validator.contains(v, `&`))
          && !(validator.contains(v, `?`))
          && !(validator.contains(v, `>`))
          && !(validator.contains(v, `<`))
          && !(validator.contains(v, `{`))
          && !(validator.contains(v, `}`))
          && !(validator.contains(v, `[`))
          && !(validator.contains(v, `]`))
        )
      )
      /* eslint-enable */
    },
    async createRoom () {
      let data = this.newRoom
      this.loading = true
      this.msgs = [
      ]

      if ((data.title + '').trim() === '') {
        if (this.msgs.findIndex(m => m.id === 0) === -1) {
          this.msgs.push({ id: 0, msg: 'Needs to fill in room title' })
        }
      }

      if (data.enableRoomAdminFeatures && (data.roomAdminPassword + '').trim() === '') {
        if (this.msgs.findIndex(m => m.id === 1) === -1) {
          this.msgs.push({ id: 1, msg: 'Needs to fill in room admin password.' })
        }
      }
      if (data.enableRoomEntryPassword && (data.roomEntryPassword + '').trim() === '') {
        if (this.msgs.findIndex(m => m.id === 2) === -1) {
          this.msgs.push({ id: 2, msg: 'Needs to fill in room entry password.' })
        }
      }

      if (this.notOkayTitleString(data.title)) {
        if (this.msgs.findIndex(m => m.id === 3) === -1) {
          this.msgs.push({ id: 3, msg: 'Room title only accept alpha numerical, - and _' })
        }
      }

      let isUnique = await this.checkUniqueTitle({ title: this.newName })

      if (this.msgs.length > 0 || !isUnique) {
        this.loading = false
        return
      }

      API.createRoom({ ...this.newRoom })
        .then((resp) => {
          this.result = resp.data
          if (window.innerWidth < 767) {
            this.$emit('bar', 'none')
          }
          this.$emit('currentRoom', resp.data)
          // setTimeout(() => {
          //   this.$emit('openMenu', false)
          // })
          this.$emit('currentRoomID', this.result._id)
          this.$forceUpdate()
          // this.$router.push(`/room/${this.result._id}`)
        }, (resp) => {
          this.msgs.push({ id: 500, msg: 'Cannot create room' })
        })
        .then(() => {
          this.newRoom = JSON.parse(JSON.stringify(this.template))
          this.loading = false
        }, () => {
          this.loading = false
        })
    }
  }
}

</script>

<style scoped>
.list-of-create-room{
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  border-right: #756365 solid 1px;
  box-sizing: border-box;
}
.list-of-create-room ::placeholder{
  color: #ca192b;
  text-align: center;
}

.red{
  color:#ca192b;
  text-decoration: underline;
}
.input-section{
  margin-top: 10px;
}

.single-input-grouper{
  display: flex;
  justify-content: center;
}

.list-of-create-room{
  /* width: 100%; */
  width: 100%;
}

@media screen and (min-width: 767px){
  .list-of-create-room{
    width: 249px;
  }
}

.red-round-box{
  border-radius: 50px;
  border: #a71524 solid 2px;
  text-align: center;
}
textarea.red-round-box{
  text-align: left;
}
.red-round-box:focus
{
  border: #ca192b solid 2px;
}
.red-textarea{
  height: 160px;
  border-radius: 10px;
}

.additional-features{
  display: block;
  margin: 0 auto;
  width: 80%;

  color: #ca192b;
}

.red-submit-btn{
  color: #ca192b;
  width: 100%;
}

.black{
  color: rgb(49, 49, 49);
}

@media screen and (min-width: 767px) {
  .hide-desktop{
    display: none;
  }
}
</style>
